var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 15C28 8.09644 22.4036 2.5 15.5 2.5C8.59644 2.5 3 8.09644 3 15C3 21.9036 8.59644 27.5 15.5 27.5C22.4036 27.5 28 21.9036 28 15Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 7.12373C24.3316 7.20795 22.8351 7.6603 21.7974 9.00347C19.9231 11.4295 18.0488 11.6319 16.7992 10.8233C14.9249 9.61025 16.5 7.64545 14.3002 6.57769C12.8664 5.88178 12.6665 3.98807 13.4645 2.5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 13.75C3.95312 14.5776 5.28807 15.3352 6.86093 15.3352C10.1105 15.3352 10.7605 15.9561 10.7605 18.4397C10.7605 20.9233 10.7605 20.9233 11.4104 22.7861C11.8331 23.9977 11.9809 25.2093 11.1382 26.25",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28 16.8154C26.8911 16.1764 25.5 15.9135 24.0918 16.9256C21.3971 18.8623 19.5392 17.2575 18.7024 18.8612C17.4706 21.2219 21.8696 21.9639 18 27.5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.6ff33d2bc875e7e8b533289b52654bd0.svg";
export { ForwardRef as ReactComponent };